import type { BaseUrl } from '@atlassian/jira-shared-types';

export type ItsmProjectType = 'ITSM';
export const ITSM_PROJECT_TYPE: ItsmProjectType = 'ITSM';

export type FirstProjectAttributes = {
	projectId: number;
	projectType: ItsmProjectType | '';
	// inexact type since this comes from the server, and we are
	// only checking for the presence of the above properties,
	// not the absence of any others
};

export type StateData = {
	firstProjectAttributes: FirstProjectAttributes | undefined;
};

export type ItsmAudienceState = {
	data: StateData | undefined;
	isLoading: boolean;
	error: Error | undefined;
};

export type ActionProps = {
	baseUrl: BaseUrl;
};
